import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'diffReport',
    label: 'Diff Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
